<template>
  <div class="page">
    <!-- 密码验证 -->
    <div v-if="!authed" class="gate">
      <div class="gate-card">
        <h1>🔐 管理员验证</h1>
        <p>请输入访问密码</p>
        <el-input v-model="pwd" type="password" placeholder="请输入密码" @keyup.enter="checkPwd" class="gate-input" />
        <el-button type="primary" @click="checkPwd" :loading="checking" class="gate-btn">验证</el-button>
        <p v-if="err" class="gate-err">{{ err }}</p>
      </div>
    </div>

    <!-- 数据面板 -->
    <div v-else class="panel">
      <div class="panel-head">
        <h2>📋 申请数据管理</h2>
        <div class="head-actions">
          <span class="total">共 {{ list.length }} 条记录</span>
          <el-button size="small" @click="refresh" :loading="loading">刷新</el-button>
          <router-link to="/" class="back-link">← 返回首页</router-link>
        </div>
      </div>

      <div class="table-wrap" v-if="list.length">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>姓名</th>
              <th>单位/公司</th>
              <th>手机号</th>
              <th>邮箱</th>
              <th>用途</th>
              <th>工具</th>
              <th>提交时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in list" :key="r.id">
              <td>{{ i + 1 }}</td>
              <td>{{ r.name }}</td>
              <td>{{ r.company || '-' }}</td>
              <td>{{ r.phone || '-' }}</td>
              <td>{{ r.email || '-' }}</td>
              <td class="purpose-cell">{{ r.purpose || '-' }}</td>
              <td><span class="tool-tag">{{ r.tool || '-' }}</span></td>
              <td class="time-cell">{{ formatTime(r.createdAt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="empty">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { regList2 } from "@/utils/http/interface";
export default {
  name: "AdminData",
  data(){ return{
    authed: false, pwd: '', err: '', checking: false,
    list: [], loading: false,
  }},
  methods:{
    checkPwd(){
      this.checking = true; this.err = '';
      if(this.pwd === 'osredmAdmin2026'){
        this.authed = true;
        this.fetchList();
      } else {
        this.err = '密码错误，请重试';
      }
      this.checking = false;
    },
    async fetchList(){
      this.loading = true;
      try {
        const res = await regList2();
        this.list = (res.data || []).sort((a,b) => b.id.localeCompare(a.id));
      } catch(e){
        this.$message.error('获取数据失败');
      }
      this.loading = false;
    },
    refresh(){ this.fetchList(); },
    formatTime(t){
      if(!t) return '-';
      const d = new Date(t);
      return d.getFullYear()+'-'+
        String(d.getMonth()+1).padStart(2,'0')+'-'+
        String(d.getDate()).padStart(2,'0')+' '+
        String(d.getHours()).padStart(2,'0')+':'+
        String(d.getMinutes()).padStart(2,'0');
    },
  },
}
</script>

<style scoped>
.page { min-height:100vh; background:#f8f7fd; display:flex; align-items:center; justify-content:center; }
.gate { }
.gate-card { background:#fff; border-radius:20px; padding:48px 40px; text-align:center; box-shadow:0 4px 20px rgba(65,84,241,0.06); max-width:380px; width:90vw; }
.gate-card h1 { font-size:22px; font-weight:800; color:#1a1744; margin:0 0 8px; }
.gate-card > p { font-size:14px; color:#6b6990; margin:0 0 24px; }
.gate-input { margin-bottom:16px; }
.gate-btn { width:100%; padding:12px 0 !important; font-weight:700 !important; border-radius:12px !important; background:linear-gradient(135deg, #4154f1, #6366f1) !important; border:none !important; }
.gate-err { color:#e74c3c; font-size:13px; margin-top:12px; }

.panel { width:min(100%, 1260px); padding:24px 24px 60px; box-sizing:border-box; }
.panel-head { display:flex; align-items:center; gap:20px; margin-bottom:20px; flex-wrap:wrap; }
.panel-head h2 { font-size:20px; font-weight:800; color:#1a1744; margin:0; white-space:nowrap; }
.head-actions { margin-left:auto; display:flex; align-items:center; gap:14px; }
.total { font-size:13px; color:#6b6990; }
.back-link { font-size:13px; color:#4154f1; text-decoration:none; font-weight:600; }

.table-wrap { overflow-x:auto; background:#fff; border-radius:16px; box-shadow:0 2px 12px rgba(65,84,241,0.03); border:1px solid rgba(65,84,241,0.04); }
table { width:100%; border-collapse:collapse; font-size:13px; }
th { background:#faf9fd; text-align:left; padding:12px 16px; font-weight:700; color:#1a1744; font-size:12px; white-space:nowrap; border-bottom:2px solid rgba(65,84,241,0.06); }
td { padding:12px 16px; color:#5b5888; border-bottom:1px solid rgba(65,84,241,0.03); }
tr:hover td { background:rgba(65,84,241,0.02); }
.purpose-cell { max-width:200px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.tool-tag { display:inline-block; padding:2px 10px; border-radius:10px; font-size:11px; font-weight:600; color:#4154f1; background:rgba(65,84,241,0.05); white-space:nowrap; }
.time-cell { white-space:nowrap; font-size:12px; color:#9b99b8; }
.empty { text-align:center; padding:60px; color:#9b99b8; font-size:14px; }

@media(max-width:768px){
  .panel { padding:16px 10px 40px; }
  .panel-head { flex-direction:column; align-items:flex-start; }
  .head-actions { margin-left:0; }
  th, td { padding:8px 10px; font-size:11px; }
}
</style>
